import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, EDIT } from "const"
import { CcReviewReviewType } from "server/models"
import { StateType, deepCopy, hasAccess, hasProjectAccess } from "client/utils"
import {
    PRM_ACCOUNT_SETTINGS,
    PRM_PROJECT_SETTINGS,
    StoreType,
    CcReviewReviewTypeList,

    LoadCcReviewReviewTypes,
    DeleteCcReviewReviewType,
    DragnDropCcReviewReviewType,

    setCcReviewReviewTypeList,
    setCcReviewReviewTypeIds,
    addModal,
} from "client/store"
import {
    Container,
    Loader,
    Button,
    Table,
    DeleteRow,
    DragnDrop,
} from "client/components"

import Columns from "./columns"
import Edit from "./edit"

const CcReviewItemType = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const typeList = useSelector((state: StoreType) => state.ccReviewReviewType.typeList)
    const typeIds = useSelector((state: StoreType) => state.ccReviewReviewType.typeIds)
    const reloadList = useSelector((state: StoreType) => state.ccReviewReviewType.reloadList)

    const accountSettings = useSelector((state: StoreType) => state.system.accountSettings)
    const projectSettings = useSelector((state: StoreType) => state.project.projectSettings)
    const { defaultReviewItemTypesAssigned } = project.id ? projectSettings.cc : accountSettings.cc

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const LoadData = () => {
        setLoadState(PENDING)
        LoadCcReviewReviewTypes(userData.accountId, project.id)
        .then((res) => {
            dispatch(setCcReviewReviewTypeList(res.typeList))
            dispatch(setCcReviewReviewTypeIds(res.typeIds))
            setLoadState(IDLE)
        })
    }

    useEffect(() => {
        if (!reloadList) return
        LoadData()
    }, [reloadList, project, defaultReviewItemTypesAssigned])

    const onDelete: DeleteRow = (type: CcReviewReviewType, callback) => {
        DeleteCcReviewReviewType(type.id).then((removedRows) => {
            const success = removedRows === 1
            callback(success, () => {
                const typeListCopy: CcReviewReviewTypeList = typeList ? deepCopy(typeList) : {}
                delete typeListCopy[type.id]
                dispatch(setCcReviewReviewTypeList(typeListCopy))
                dispatch(setCcReviewReviewTypeIds(typeIds.filter((id) => id !== type.id)))
            })
        })
    }

    const onDragnDrop: DragnDrop = (dataIds, callback) => {
        dispatch(setCcReviewReviewTypeIds(dataIds))
        setLoadState(PENDING)
        DragnDropCcReviewReviewType(dataIds, typeList).then((success) => {
            LoadData()
            callback(success)
        })
    }

    const editAccess = !project.id
        ? hasAccess(PRM_ACCOUNT_SETTINGS, EDIT)
        : hasProjectAccess(PRM_PROJECT_SETTINGS, EDIT)

    const columns = Columns(editAccess)
    return (
        <Container>
            {
                loadState === PENDING
                && <Loader />
            }
            <Table
                columns={columns}
                dataList={typeList}
                dataIds={typeIds}
                rowSize="sm"
                showPagination={false}
                onDelete={onDelete}
                onDragnDrop={onDragnDrop}
                bottomContent={editAccess && (
                    <Button
                        variant="success"
                        onClick={() => dispatch(addModal({
                            key: "addReviewType",
                            content: <Edit typeId={0} editAccess={editAccess} />,
                        }))}
                    >
                        {lang.add}
                    </Button>
                )}
            />
        </Container>
    )
}
export default CcReviewItemType
